'use client';

import React from 'react';

import { cn } from '@/lib/utils';

import { formatTime } from '../utils';

type TimeDisplayProps = {
	time: number;
	className?: string;
};

function TimeDisplay({ time, className }: TimeDisplayProps) {
	return (
		<span className={cn('text-xs font-medium text-white', className)}>{formatTime(time)}</span>
	);
}

export default React.memo(TimeDisplay);
